import template	from "./view-devices.html";
import css		from "./view-devices.css";

import Page			from "../view-page.js";
import { Label }	from "gui";
import { Icon }		from "gui";
import { Button }	from "gui";
import { Division }	from "gui";
import Datatable	from "datatable";
import moment		from  "moment";

export default class DevicesView extends Page {
  static get template() {
    return template;
  }
  
  static get css() {
    return css;
  }
  
  static {
    customElements.define("fulljs-view-devices", DevicesView);
  } 
  
  async connectedCallback(...args) {
    await super.connectedCallback(...args);

    await this.table_update();
  }     
  
  constructor(...args) {
    super(...args);
  }
  
  textboxSearch_keyup() {
    this.table_update();
  }    
  
  table_update() {        
    if (this.abortController) this.abortController.abort();        

    this.abortController = new AbortController();
    this.table_load({ signal: this.abortController.signal });    
  }  
  
  async #config_device(device) {
    console.log(device);
    let dir = device.usbProductName.toLowerCase().replace(/ /g, '_');
    let module = await import(`../../peripherals/${dir}/dialog-config.js`);
    let ConfigDialog = module.default;
    let configDialog = new ConfigDialog({
      name: device.name,
      endpoint: device.usbProductName+"_"+device.usbSerialNumber
    });    
    //configDialog.show(device);
  }
  
  async table_load({ signal } = {}) {
    this.datatable1.replaceChildren(this.datatable1.children[0]);

    const response = await fetch("/api/pc/devices", {
      method: "GET",
      headers: {
        "Accept": "application/json"
      }
    });

    if (!response.ok) {
      throw new Error(`Failed to load devices: ${response.statusText}`);
    }

    let items = await response.json();    
    items = Object.values(items).map(obj => ({ ...obj }));
    
    items = items.filter(function(o) { 
      return Object.values(o).join("").normalize('NFD').replace(/\p{Diacritic}/gu, '').toUpperCase().includes(this.textboxSearch.value.normalize('NFD').replace(/\p{Diacritic}/gu, '').toUpperCase());
    }.bind(this));    

    for await (const item of items) {
      signal?.throwIfAborted();

      let row = this.datatable1.appendChild( new Datatable.Row({
        ondblclick: this.#config_device.bind(this, item)
      }) );
      
      row.appendChild( new Icon({context: "devices", size: 16, iconname: "drive-removable-media-usb"}) );
      
      if (item.errorcodes) 
        row.appendChild( new Icon({context: "status", size: 16, iconname: "dialog-warning"}) );
      else 
        row.appendChild( new Icon({context: "actions", size: 16, iconname: "dialog-ok"}) );
            
      row.appendChild( new Label({ value: item.name }) );
      row.appendChild( new Label({ value: "" }) );
      
      let div = row.appendChild( new Division() );
      div.appendChild( new Button({
        label: new Label({
          value: "Configure"
        }),
        icon: new Icon({
          context: "actions",
          size: 16,
          iconname: "configure"
        }),
        onclick: this.#config_device.bind(this, item)
      }) );
    } 
  }  
}